import { parse, format } from 'date-fns'

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const DAYS_SHORT = ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun']
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
export const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const getMonthFromNumber = (month: number) => {
  return MONTHS[month - 1]
}
export const getShortMonthFromNumber = (month: number) => {
  return MONTHS_SHORT[month - 1]
}

export const getShortMonthNameFromDate = (date: Date) => {
  return date.toLocaleString('default', { month: 'short' })
}

export const getShortYearFromDate = (date: Date) => {
  return date.toLocaleString('default', { year: '2-digit' })
}

export const getDayFromDate = (date: Date) => {
  return date.toLocaleString('default', { weekday: 'long' })
}

export const getHourOfDay = (hourNumber: number) => {
  let hour = hourNumber % 12
  if (hour === 0) {
    hour = 12
  }
  return `${hour < 10 ? '0' : ''}${hour} ${hourNumber >= 12 ? 'PM' : 'AM'}`
}

export const getTimestampFilename = (extension: string) => {
  const now = format(new Date(), 'MM-dd-yyyy-hh-mm-ss-aaa')
  return `alphamap-${now}.${extension}`
}

export const localDate = (dateInput: string) => {
  const parsedInput = dateInput.split('T')
  const date = parse(parsedInput[0], 'yyyy-MM-dd', new Date())
  return date
}

export const formatDocumentDate = (dateInput: string) => {
  return format(localDate(dateInput), 'MM/dd/yy')
}

export const formatDateMMMMDDYYYY = (dateInput: string) => {
  return format(localDate(dateInput), 'MMMM dd, yyyy')
}

export const getDateWithoutBloodyTZ = (dateInput: string) => {
  const inputDate = new Date(dateInput)
  return getDateWithoutBloodyTZFromDate(inputDate)
}

export const getDateWithoutBloodyTZFromDate = (date: Date) => {
  const userOffsetMinutes = Math.abs(date.getTimezoneOffset())
  const utcMillis = date.getTime() + userOffsetMinutes * 60 * 1000
  const utcDate = new Date(utcMillis)
  return utcDate
}

export function getQuarter(d: Date) {
  const month = d.getMonth() + 1
  return Math.ceil(month / 3)
}

export function getStripeEpoch(date: number) {
  return new Date(date * 1000).getTime()
}

// gets the time between to dates in days/months/years depending on the difference
export function formatTimePeriod(start: Date, end: Date) {
  const days = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
  if (days < 30) {
    return `${days} days`
  }

  const months = Math.floor(days / 30)
  const remainingDays = days % 30
  const remainingDaysText = remainingDays > 0 ? ` and ${remainingDays} day${remainingDays > 1 ? 's' : ''}` : ''
  // return months and days
  if (months < 12) {
    return `${months} month${months > 1 ? 's' : ''} ${remainingDaysText}`
  }

  const years = Math.floor(months / 12)
  const remainingMonths = months % 12
  const remaaingMonthsText = remainingMonths > 0 ? ` and ${remainingMonths} month${remainingMonths > 1 ? 's' : ''}` : ''
  // return years and months
  return `${years} year${years > 1 ? 's' : ''} ${remaaingMonthsText}`
}

export const convertDateToString = (date: Date) => {
  return date.toISOString().split('T')[0]
}

export const getCurrentYear = () => {
  const date = getDateWithoutBloodyTZFromDate(new Date())
  return date.getFullYear()
}
